import { createCrudHooks } from "../common/queries";

export const termApi = createCrudHooks({
	baseKey: "terms",
	basePath: "/terms",
	getParams: { include: [{association: 'topics', include: [{ association: 'ratings'}]}, { association: 'enrollments', include: [{ association: 'course', include: ['subject'] }, 'student'] }] },
});
